import React from "react";

/**
 * Desktop instructions for skincare test
 *
 * @returns {JSX.Element}
 */
export default function DesktopInstructions() {
    return (
        <>
            <h2 className="text-2xl text-center font-bold leading-6 text-gray-900">
                Toma una selfie
            </h2>
            <div className="mt-2 max-w-sm mx-auto">
                <p className="text-base text-black text-center">
                    Alinee su rostro y ojos con las líneas y siga estos pasos
                    para obtener el mejor escaneo.
                </p>
            </div>
            <div className="flex items-center w-full md:w-5/6 mx-auto space-x-6 mt-4">
                <div className="w-20 h-20 rounded-full bg-[#e4eefc] flex justify-center items-center">
                    <img
                        src="/img/selfie_step_one.svg"
                        alt=""
                        className="w-12 h-12 object-contain"
                    />
                </div>
                <div className="flex-1">
                    <p className="text-base">
                        Retira tu cabello hacia atrás y elimina cualquier cosa
                        que hiera tu piel.
                    </p>
                </div>
            </div>

            <div className="flex items-center w-full md:w-5/6 mx-auto space-x-6 mt-4">
                <div className="w-20 h-20 rounded-full bg-[#e4eefc] flex justify-center items-center">
                    <img
                        src="/img/selfie_step_two.svg"
                        alt=""
                        className="w-12 h-12 object-contain"
                    />
                </div>
                <div className="flex-1">
                    <p className="text-base">
                        Use un área bien preparada para cada escaneo. La
                        iluminación que es demasiado brillante u oscura puede
                        hacer que sea difícil escanear su cara.
                    </p>
                </div>
            </div>

            <div className="flex items-center w-full md:w-5/6 mx-auto space-x-6 mt-4">
                <div className="w-20 h-20 rounded-full bg-[#e4eefc] flex justify-center items-center">
                    <img
                        src="/img/selfie_step_three.svg"
                        alt=""
                        className="w-12 h-12 object-contain"
                    />
                </div>
                <div className="flex-1">
                    <p className="text-base">Relaja tu rostro. Sin sonreír.</p>
                </div>
            </div>

            <div className="flex items-center w-full md:w-5/6 mx-auto space-x-6 mt-4">
                <div className="w-20 h-20 rounded-full bg-[#e4eefc] flex justify-center items-center">
                    <img
                        src="/img/selfie_step_four.svg"
                        alt=""
                        className="w-12 h-12 object-contain"
                    />
                </div>
                <div className="flex-1">
                    <p className="text-base">
                        Asegúrate de que tu cara esté limpia de cualquier
                        producto.
                    </p>
                </div>
            </div>
        </>
    );
}
